import { gql } from "@apollo/client";

export const GET_PIPELINE_STATUS = gql`
  query resourcesRun($siteId: SiteID!, $runId: ID!) {
    resourcesRun(siteId: $siteId, runId: $runId) {
      status
    }
  }
`;
